import React from "react";

export default function PromoCode({active, code}) {

  if (active !== true) return null;
  return (
    <div className="PromoCode">
      <span className="prefix">Applied Code: </span><span className="code">{code}</span>
    </div>
  )
}

PromoCode.defaultProps = {
  active: false,
  code: ""
}